import { Injectable } from '@angular/core';
import {HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {AuthenticationService} from "./authentication.service";
import {StorageService} from "./storage.service";

@Injectable()
export class AuthInterceptorService implements HttpInterceptor{

  constructor(private authService: AuthenticationService, private storage: StorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.authToken === null) {
      //console.log("No authentication data");
      next.handle(req);
    }
    let currValue = this.authService.authToken.getValue();
    const fixedReq = req.clone({
      headers: req.headers.set('Authorization',`bearer ${currValue}`)
    });
    return next.handle(fixedReq);
  }
}
